import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  RedoOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import { useSelector } from "react-redux";

export default function Actions({ record, onEdit, onReset, onDelete }) {
  const { userInfo } = useSelector((state) => state.auth);

  const KEY_ACTIONS = {
    EDIT: "edit",
    RESET: "reset",
    DELETE: "delete",
  };

  const onClick = ({ key }) => {
    switch (key) {
      case KEY_ACTIONS.EDIT:
        onEdit(record);
        break;
      case KEY_ACTIONS.RESET:
        onReset(record);
        break;
      case KEY_ACTIONS.DELETE:
        onDelete(record);
        break;
      default:
        break;
    }
  };

  const actions = [
    {
      key: KEY_ACTIONS.EDIT,
      label: "Sửa",
      icon: <EditOutlined />,
    },
    {
      key: KEY_ACTIONS.RESET,
      label: "Reset",
      icon: <RedoOutlined />,
    },
    {
      key: KEY_ACTIONS.DELETE,
      danger: true,
      label: "Xóa",
      icon: <DeleteOutlined />,
    },
  ];

  return (
    <Dropdown menu={{ items: actions, onClick }}>
      <Button>
        <Space>
          Thao tác
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
}
